import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=d83c71ac"
import script from "./CartIcon.vue?vue&type=script&lang=ts"
export * from "./CartIcon.vue?vue&type=script&lang=ts"
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=d83c71ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports